import React from 'react';
//import {RouteState, ROUTE_UPDATE_EVENT, ENABLE_EVENT} from '../../state/routing/index';
import { toggleDraw, toggleActive, clearDraw } from '../draw/actions';
import { connect } from 'react-redux';
import { submitReport, mapMistakesEnable, changeFormState, startSending } from './actions';
import MapMistakes from '../components/mapMistakes/index';
import { clearMesureTooltips } from '../draw/ruler';

const mapStateToPropsRes = (state) => {

  if(state.mapMistakes.formState === 'finished') {

    var message = window.displayText('MAP_MISTAKES_SUBMIT_SUCCESS');
  } else {

    var message = window.displayText('MAP_MISTAKES_SUBMIT_FAILED');
  }
  
  

  return {
    enabled: state.mapMistakes.enabled,
    mapurl: state.url.url,
    contentPanelProps: {formState: state.mapMistakes.formState, finMessage: message, started: state.mapMistakes.startSending}
  };
};

const mapDispatchToPropsRes = (dispatch) => {

  return {
    submitHandler: data => {
      
      dispatch(startSending());
      data.geometryURL = data.mapurl;

      dispatch(submitReport(data));
    },
    handleDraw: name => event => {
      if (name=="Clear") {
        dispatch(clearDraw({updateSource: 'UI'}));
        clearMesureTooltips();
      } else {
        dispatch(toggleDraw({drawType: name}));
      }
    },
    StartNewHandler: () => {
      dispatch(changeFormState("default"));
    },
    closeHandler: () => {

      dispatch(mapMistakesEnable(false));
      dispatch(clearDraw({updateSource: 'UI'}));
      clearMesureTooltips();
    }
  };
};

const MapMistakesCont = connect(
  mapStateToPropsRes,
  mapDispatchToPropsRes
)(MapMistakes);

export default MapMistakesCont;


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/mapMistakes/container.js